import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    documentsSchema,
    defaultDocumentsConfig,
    defaultDocumentsData,
    defaultDocumentsI18n,
    listPageBlocks,
    hasConfiguredOfficeDocument,
    normalizeDocumentsCompletion,
    type DocumentsContent,
    type DocumentsData,
    type DocumentsConfig,
    type DocumentsAnswer,
} from './schema';

export { DocumentsEdit, type DocumentsEditProps } from './DocumentsEdit';
export { DocumentsPlayer, type DocumentsPlayerProps } from './DocumentsPlayer';

export {
    documentsContentGrader,
    validateDocumentsSubmission,
} from './grader';
export { documentsValidator } from './validator';

export { documentsSchema as default } from './schema';

export { countDocumentsQuestions, documentsQuestionCounter } from './questionCount';
